class Content {
	title
	alias
	desc
	img
	text
	link
	file
	template
	element

	render (postIndex) {
		if (this.element) return this.element
		this.element = this.template.getElement(this, postIndex)
		return this.element
	}
}

export { Content }



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_news_loader/entities/Content.js